import React, { useEffect, useState } from 'react';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { FlagsProvider, useFlags } from '@atlaskit/flag';
import { ModalTransition } from '@atlaskit/modal-dialog';
import { ContextualAnalyticsData, FireScreenAnalytics, SCREEN } from '@atlassian/analytics-bridge';
import { ErrorBoundary } from '@atlassian/proforma-common-core/jira-common';
import { InProductHelpProvider, PfFlagsProvider, UtilsProvider } from '@atlassian/proforma-common-core/jira-common-context';
import { createUtils } from '@atlassian/proforma-common-core/jira-common-utils';
import { AnalyticsProvider } from '@atlassian/proforma-utils/analytics';
import { PackageIntlProvider } from '../common/utils/intl-provider';
import { ProjectFormsContainer } from '../controllers';
import { IssueFormsApiProvider, LiveIssueFormsApi } from '../services/issue-forms-api';
import { LiveProjectApi, ProjectApiProvider } from '../services/project-api';
import { LiveProjectFormApi, ProjectFormApiProvider } from '../services/project-form-api';
import { LiveRequestTypeApi, RequestTypeApiProvider } from '../services/request-type-api';
import { LiveTemplateFormApi, TemplateFormApiProvider } from '../services/template-form-api';
import { ProjectForms } from './project-forms';
const JiraProjectFormsBaseApp = ({
  settings
}) => {
  var _settings$context$use;
  const {
    showFlag
  } = useFlags();
  const {
    createAnalyticsEvent
  } = useAnalyticsEvents();
  const [moduleContext, setModuleContext] = useState();
  useEffect(() => {
    const utils = createUtils(settings, 'ProjectForms', showFlag, createAnalyticsEvent, settings.context.intlLocale);
    setModuleContext({
      apis: {
        issueFormsApi: new LiveIssueFormsApi(settings.context.projectId, utils.apiUtil),
        projectFormApi: new LiveProjectFormApi(settings.context.projectId, utils.apiUtil),
        templateFormApi: new LiveTemplateFormApi(utils.apiUtil),
        projectApi: new LiveProjectApi(utils.apiUtil),
        requestTypeApi: new LiveRequestTypeApi(settings.context.projectId, utils.apiUtil)
      },
      utils: {
        errorUtils: utils.errorUtils
      }
    });
  }, [createAnalyticsEvent, settings, showFlag]);
  if (!moduleContext) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  return /*#__PURE__*/React.createElement(ErrorBoundary, {
    errorUtils: moduleContext.utils.errorUtils
  }, /*#__PURE__*/React.createElement(PfFlagsProvider, {
    flags: settings.flags
  }, /*#__PURE__*/React.createElement(UtilsProvider, {
    utils: moduleContext.utils
  }, /*#__PURE__*/React.createElement(ProjectApiProvider, {
    projectApi: moduleContext.apis.projectApi
  }, /*#__PURE__*/React.createElement(ProjectFormApiProvider, {
    projectFormApi: moduleContext.apis.projectFormApi
  }, /*#__PURE__*/React.createElement(TemplateFormApiProvider, {
    templateFormApi: moduleContext.apis.templateFormApi
  }, /*#__PURE__*/React.createElement(RequestTypeApiProvider, {
    requestTypeApi: moduleContext.apis.requestTypeApi
  }, /*#__PURE__*/React.createElement(InProductHelpProvider, {
    inProductHelpData: settings.context.inProductHelpData
  }, /*#__PURE__*/React.createElement(IssueFormsApiProvider, {
    issueFormsApi: moduleContext.apis.issueFormsApi
  }, /*#__PURE__*/React.createElement(ProjectFormsContainer, {
    errorUtils: moduleContext.utils.errorUtils,
    projectFormApi: moduleContext.apis.projectFormApi
  }, /*#__PURE__*/React.createElement(ProjectForms, {
    projectId: settings.context.projectId,
    projectKey: settings.context.projectKey,
    projectType: settings.context.projectType,
    simplifiedProject: settings.context.inProductHelpData.simplifiedProject,
    userIsProjectAdmin: (_settings$context$use = settings.context.userIsProjectAdmin) !== null && _settings$context$use !== void 0 ? _settings$context$use : false
  }))))), /*#__PURE__*/React.createElement(FireScreenAnalytics, null), /*#__PURE__*/React.createElement(ModalTransition, null, /*#__PURE__*/React.createElement("div", {
    id: "pf-dialog-container"
  }))))))));
};

/* eslint-disable react/destructuring-assignment */
/**
 * When using this component, ensure:
 *  * it is wrapped by an `AnalyticsListener`, if you want to listen to analytics events
 *  * the `settings` property is static and does not change unless necessary (e.g. wrap it in `useState`)
 */
export const JiraProjectFormsApp = props => /*#__PURE__*/React.createElement(AnalyticsProvider, props.settings.analytics, /*#__PURE__*/React.createElement(ContextualAnalyticsData, {
  sourceName: "proformaJiraProjectForms",
  sourceType: SCREEN,
  attributes: getAnalyticsAttributes(props.settings.context)
}, /*#__PURE__*/React.createElement(PackageIntlProvider, {
  locale: props.settings.context.intlLocale
}, /*#__PURE__*/React.createElement(FlagsProvider, null, /*#__PURE__*/React.createElement(JiraProjectFormsBaseApp, props)))));
/* eslint-enable react/destructuring-assignment */

const getAnalyticsAttributes = settings => {
  const {
    projectId,
    projectType
  } = settings;
  return {
    projectId,
    projectType
  };
};